export default {
	name	: 'courses-loader',
	data() {
		return {
			currentMessageIndex	: 0,
			progress			: 0,
			loadingMessages		: [
				'Оновлюємо ваш прогрес',
				'Перевіряємо підписку',
				'Синхронізуємо навчальні дані',
				'Готуємо ваші курси',
				'Оптимізуємо дані',
				'Синхронізуємо ваш профіль',
				'Завантажуємо контент'
			],
			messageInterval		: null,
			progressInterval	: null
		}
	},
	mounted() {
		//console.log('courses-loader mounted');
		
		this.startAnimations();
	},
	beforeDestroy() {
		this.stopAnimations();
	},
	methods: {
		startAnimations() {
			//alert(this.loadingMessages.length);
			
			//this.messageInterval = setInterval(() => {
			//	this.currentMessageIndex = (this.currentMessageIndex + 1) % this.loadingMessages.length;
			//}, 1500);
			
			this.progressInterval = setInterval(() => {
				if (this.progress >= 100) {
					//this.progress = 0;
					
					if(this.currentMessageIndex < (this.loadingMessages.length-1)){
						this.progress = 0;
						this.currentMessageIndex += 1;
					}else{
						clearInterval(this.progressInterval);
						this.progressInterval = null;
					}
				} else {
					this.progress += 2;
					
					if(this.progress > 100){
						this.progress = 100;
					}
				}
			}, 100);
		},
		stopAnimations() {
			if (this.messageInterval) {
				clearInterval(this.messageInterval);
				this.messageInterval = null;
			}
			
			if (this.progressInterval) {
				clearInterval(this.progressInterval);
				this.progressInterval = null;
			}
			
			this.progress = 0;
			this.currentMessageIndex = 0;
		}
	}
}
